export enum BlockTypes {
    HEADER_H1 = "h1",
    HEADER_H2 = "h2",
    HEADER_H3 = "h3",
    PARAGRAPH = "paragraph",
    LIST_UNORDERED = "list_unordered",
    LIST_ORDERED = "list_ordered",
}